module.exports = __webpack_public_path__ + "static/media/email.a5fb08d4.png";